
        <!-- {{data}} -->
        <!-- <div style="height: 100vh; width: 100vw;"> -->
        <div id="snackbar" class="show" style="top: 50%;display:flex;justify-content: center;">
          <div class="message">{{data}}</div>
          <!-- <div class="dismiss" (click)="dismissToast()">DISMISS</div> -->
        </div>
      <!-- </div> -->
